<div class="page-layout carded fullwidth inner-scroll" [@animate]="{value:'*',params:{delay:'200ms', y:'25px'}}">

    <!-- TOP BACKGROUND -->
    <div class="top-bg warn"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- CONTENT HEADER -->
        <div class="header warn p-24" fxLayout="row" fxLayoutAlign="start center">
            <h2 class="m-0">{{'WIZARD.NOPRODUCTS.TITULO' | translate}}</h2>
        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">

            <!-- CONTENT TOOLBAR -->
            <div class="toolbar primary px-24 py-8">
                <!-- <span>{{'WIZARD.NOPRODUCTS.SUBTI' | translate}}</span> -->
            </div>
            <!-- / CONTENT TOOLBAR -->

            <!-- CONTENT -->
            <div class="content p-24" fusePerfectScrollbar>

                <!-- <fuse-demo-content></fuse-demo-content> -->
                <div class="" fxLayout="row" fxLayoutAlign="center center">
                  <img src="assets/logo_GO2.png" class="mt-40" alt="">
                </div>

            </div>
            <!-- / CONTENT -->

        </div>
        <!-- / CONTENT CARD -->

    </div>
    <!-- / CENTER -->

</div>
